module.exports = __webpack_public_path__ + "tables2.webp?47c88a21ea8275fed44ba00e8e7c15a5";